const hook = {
    missing_events: 'คุณต้องระบุเหตุการณ์อย่างน้อยหนึ่งรายการ',
    send_test_payload_failed: 'ส่งข้อมูลทดสอบไม่สำเร็จ: {{message}}',
    endpoint_responded_with_error: 'ปลายทางตอบกลับด้วยข้อผิดพลาด',
};
export default Object.freeze(hook);
